<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">
      {{ isEditMode ? ("new.hire.edit.class.dialog.title" | translate) : ("new.hire.add.class.dialog.title" | translate) }}
    </h2>
    <button [disabled]="!enableCancel" type="button" value="Close" class="close" aria-label="Close"
            title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="dismiss()">
      <esp-icon name="x"></esp-icon>
    </button>
  </div>
  <div class="modal-body">
<!--    <wfm-plan-loading-overlay *ngIf="isLoading"></wfm-plan-loading-overlay>-->

    <div class="col-12">
      <form [formGroup]="addClassForm" (submit)="submit()">

        <!-- Plan Date Range Display -->
        <div class="row">
          <div class='col-12 form-group'>
            <label class="input-label">
              {{"plan.date.range.label"|translate }}
            </label>
            <div class="plan-date-range">
              {{planStartDate}} - {{planEndDate}}
            </div>
          </div>
        </div>

        <!-- Learning Curve Name Display -->
        <div class="row">
          <div class='col-12 form-group'>
            <label class="input-label">
              {{"new.hire.learning.curve.label"|translate}}
            </label>
            <div class="learning-curve-name">
              {{selectedLearningCurve?.name}} ({{selectedLearningCurve?.trainingWeeks}} {{"plan.settings.weeks"|translate}})
            </div>
          </div>
        </div>

        <!-- Management Unit Selection -->
        <div class="row">
          <div class='col-8 form-group'>
            <label class="input-label" for="managementUnits">
              <span id="managementUnitsLabel">{{"new.hire.management.unit.label"|translate}}</span>
              <span class="text-danger" aria-hidden="true" *ngIf="!isEditMode">*</span>
            </label>

            <!-- Show dropdown for add mode -->
            <p-multiselect #muSelector
            class="filterable toolbar-select no-x-scroll mu-multiselect"
              *ngIf="!isEditMode"
              (click)="onManagementUnitContainerClick($event)"
              formControlName="managementUnits"
              inputId="managementUnits"
              [ariaLabel]="'new.hire.management.unit.label' | translate"
              [required]="true"
              [options]="managementUnits"
              [showToggleAll]="false"
              [virtualScroll]="true"
              [virtualScrollItemSize]="40"
              [virtualScrollOptions]="virtualScrollOptions"
              optionLabel="label"
              optionValue="value"
              placeholder=" "
              styleClass="fullrow"
              [showClear]="false"
              [showHeader]="true"
              [filter]="false"
              (onChange)="updateSelectedMUs()"
              (onPanelHide)="onMuPanelHide()"
              [(ngModel)]="selectedMUs"
              [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
              emptyFilterMessage="{{'plan.details.dropdown.management.units.empty' | translate}}">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.management.units.empty.selection"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="muSelector">
                </esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="muSelector">
                </esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>

            <!-- Show read-only label for edit mode -->
            <div *ngIf="isEditMode" class="learning-curve-name">
              {{ getManagementUnitDisplayName() }}
            </div>

            <div *ngIf="!isEditMode && addClassForm.get('managementUnits')?.errors?.required && addClassForm.get('managementUnits')?.touched" class="error-message">
              {{"field.required.msg"|translate}}
            </div>
          </div>
        </div>

        <!-- FTE Count -->
        <div class="row">
          <div class='col-8 form-group'>
            <label class="input-label" for="fteCount">
              <span id="fteCountLabel">{{"new.hire.fte.count.label"|translate}}</span>
              <span class="text-danger" aria-hidden="true">*</span>
            </label>
            <p-inputnumber
              formControlName="fteCount"
              inputId="fteCount"
              ariaLabelledBy="fteCountLabel"
              ariaRequired="true"
              mode="decimal"
              [useGrouping]="false"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              allowEmpty="true"
              [min]="0"
              [max]="99999.99"
              placeholder=""
              styleClass="fullrow">
            </p-inputnumber>
            <div *ngIf="addClassForm.get('fteCount').errors?.required && addClassForm.get('fteCount').touched" class="error-message">
              {{"field.required.msg"|translate}}
            </div>
            <div *ngIf="addClassForm.get('fteCount').errors?.min && addClassForm.get('fteCount').touched" class="error-message">
              {{fteCountErrorMessage}}
            </div>
          </div>
        </div>

        <!-- Starting Date -->
        <div class="row">
          <div class='col-8 form-group'>
            <label class="input-label" for="startingDate">
              <span id="startingDateLabel">{{"new.hire.starting.date.label"|translate}}</span>
              <span class="text-danger" aria-hidden="true">*</span>
            </label>
            <p-datepicker
              espDatepickerDayAriaLabels
              formControlName="startingDate"
              inputId="startingDate"
              ariaLabelledBy="startingDateLabel"
              [required]="true"
              [dateFormat]="_datesFormat"
              [showIcon]="true"
              [showOnFocus]="false"
              [todayButtonStyleClass]="'invisible'"
              [minDate]="minDate"
              [maxDate]="startingDateMaxDate"
              [defaultDate]="startingDateDefaultDate"
              [disabledDays]="startingDateDisabledDays"
              [keepInvalid]="true"
              readonlyInput="true"
              [showButtonBar]="true"
              [placeholder]="_datePlaceholder"
              styleClass="fullrow">
            </p-datepicker>
            <div id="startingDatePanel" class="sr-only"></div>
          </div>
        </div>

        <!-- Ending Date -->
        <div class="row">
          <div class='col-8 form-group'>
            <label class="input-label" for="endingDate">
              <span id="endingDateLabel">{{"new.hire.ending.date.label"|translate}}</span>
              <span class="text-danger" aria-hidden="true">*</span>
            </label>
            <p-datepicker
              espDatepickerDayAriaLabels
              formControlName="endingDate"
              inputId="endingDate"
              ariaLabelledBy="endingDateLabel"
              [required]="true"
              [dateFormat]="_datesFormat"
              [showIcon]="true"
              [showOnFocus]="false"
              [todayButtonStyleClass]="'invisible'"
              [minDate]="endingDateMinDate"
              [maxDate]="maxDate"
              [defaultDate]="endingDateDefaultDate"
              [disabledDays]="endingDateDisabledDays"
              [keepInvalid]="true"
              [showButtonBar]="true"
              readonlyInput="true"
              [placeholder]="_datePlaceholder"
              styleClass="fullrow">
            </p-datepicker>
            <div id="endingDatePanel" class="sr-only"></div>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.save'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!isFormValid || isLoading"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
